const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxFilledUtilitia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,4C22,1.792 20.208,0 18,0L4,0C1.792,0 0,1.792 0,4L0,18C0,20.208 1.792,22 4,22L18,22C20.208,22 22,20.208 22,18L22,4Z",
    style: {
      fill: "rgb(0, 123, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(14,0,0,14,4,16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.917,-0.579C0.927,-0.569 0.932,-0.556 0.932,-0.541C0.932,-0.526 0.927,-0.514 0.917,-0.503L0.437,-0.023C0.427,-0.013 0.414,-0.008 0.399,-0.008C0.384,-0.008 0.371,-0.013 0.361,-0.023L0.083,-0.301C0.073,-0.312 0.068,-0.324 0.068,-0.339C0.068,-0.354 0.073,-0.367 0.083,-0.377L0.159,-0.453C0.169,-0.464 0.182,-0.469 0.197,-0.469C0.212,-0.469 0.225,-0.464 0.235,-0.453L0.399,-0.289L0.765,-0.655C0.775,-0.666 0.788,-0.671 0.803,-0.671C0.818,-0.671 0.831,-0.666 0.841,-0.655L0.917,-0.579Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxFilledUtilitia);
export default __webpack_public_path__ + "static/media/check-box-filled-utilitia.2f3f03d8f9761ce71be8984835e3369d.svg";
export { ForwardRef as ReactComponent };